import { FC, useEffect } from 'react';

import { LoaderLogin } from '@/common/components';
import { PATHS } from '@common/constants';
import { useAuth } from '@modules/auth/hooks';

const LoginCallbackError: FC<{ error: Error }> = ({ error }) => {
  const { authService } = useAuth();

  useEffect(() => {
    const id = setTimeout(() => {
      authService.clearStorage();
      (window as Window).location = PATHS.ROOT;
    }, 2000);

    return () => {
      clearTimeout(id);
    };
  }, [error]);

  return <LoaderLogin />;
};

export default LoginCallbackError;
